// Asset to Function Mappings
// Only includes assets that exist in public/Games/icons/*.png
// Names use proper spacing, imagePath uses the actual filename

export const FUNCTION_ASSET_MAPPINGS = {
  'Eat': [
    { name: 'Cookies', imagePath: 'cookies' },
    { name: 'Chips', imagePath: 'chips' },
    { name: 'Fries', imagePath: 'fries' },
    { name: 'Apple', imagePath: 'apple' },
    { name: 'Burger', imagePath: 'burger' },
    { name: 'Ice Cream', imagePath: 'icecream' },
    { name: 'Pizza', imagePath: 'pizza' },
    { name: 'Brownie', imagePath: 'brownie' },
    { name: 'Lollipop', imagePath: 'lollipop' },
    { name: 'Marshmallow', imagePath: 'marshmallow' },
    { name: 'Cracker', imagePath: 'cracker' },
    { name: 'Bread', imagePath: 'bread' },
    { name: 'Mango', imagePath: 'mango' },
    { name: 'Strawberry', imagePath: 'strawberry' },
    { name: 'Cherries', imagePath: 'cherries' },
    { name: 'Fork', imagePath: 'fork' },
    { name: 'Spoon', imagePath: 'spoon' },
    { name: 'Chopstick', imagePath: 'chopstick' },
  ],

  'Drink': [
    { name: 'Milk', imagePath: 'milk' },
    { name: 'Orange Juice', imagePath: 'orangejuice' },
    { name: 'Tea', imagePath: 'tea' },
    { name: 'Cup', imagePath: 'cup' },
    { name: 'Water Bottle', imagePath: 'waterbottle' },
    { name: 'Water Glass', imagePath: 'waterglass' },
    { name: 'Straw', imagePath: 'straw' },
  ],

  'Play': [
    { name: 'Guitar', imagePath: 'guitar' },
    { name: 'Piano', imagePath: 'piano' },
    { name: 'Violin', imagePath: 'violin' },
    { name: 'Drums', imagePath: 'drums' },
    { name: 'Harp', imagePath: 'harp' },
    { name: 'Ball', imagePath: 'ball' },
    { name: 'Swing', imagePath: 'swing' },
    { name: 'Slide', imagePath: 'slide' },
    { name: 'Blocks', imagePath: 'blocks' },
    { name: 'Doll', imagePath: 'doll' },
    { name: 'Puzzle', imagePath: 'puzzle' },
    { name: 'Monkey Bar', imagePath: 'monkeybar' },
    { name: 'Spinning Top', imagePath: 'spinningtop' },
  ],

  'Drive': [
    { name: 'Car', imagePath: 'car' },
    { name: 'Van', imagePath: 'van' },
    { name: 'Train', imagePath: 'train' },
    { name: 'Bus', imagePath: 'bus' },
    { name: 'Truck', imagePath: 'truck' },
    { name: 'Scooter', imagePath: 'scooter' },
  ],

  'Ride': [
    { name: 'Bicycle', imagePath: 'bike' },
    { name: 'Scooter', imagePath: 'scooter' },
    { name: 'Skateboard', imagePath: 'skateboard' },
    { name: 'Car', imagePath: 'car' },
    { name: 'Van', imagePath: 'van' },
    { name: 'Train', imagePath: 'train' },
    { name: 'Bus', imagePath: 'bus' },
    { name: 'Truck', imagePath: 'truck' },
    { name: 'Boat', imagePath: 'boat' },
  ],

  'Carry': [
    { name: 'School Bag', imagePath: 'schoolbag' },
    { name: 'Box', imagePath: 'box' },
  ],

  'Read': [
    { name: 'Paper', imagePath: 'paper' },
    { name: 'Book', imagePath: 'book' },
    { name: 'Magazine', imagePath: 'magazine' },
    { name: 'Newspaper', imagePath: 'newspaper' },
    { name: 'Map', imagePath: 'map' },
    { name: 'Catalogue', imagePath: 'catalogue' },
  ],

  'Brush': [
    { name: 'Teeth', imagePath: 'teeth' },
    { name: 'Comb', imagePath: 'comb' },
    { name: 'Toothbrush', imagePath: 'toothbrush' },
    { name: 'Brush', imagePath: 'brush' },
    { name: 'Paint Brush', imagePath: 'paintbrush' },
  ],

  'Turn on': [
    { name: 'TV', imagePath: 'tv' },
    { name: 'Radio', imagePath: 'radio' },
    { name: 'Light Bulb', imagePath: 'lightbulb' },
    { name: 'iPad', imagePath: 'ipad' },
    { name: 'iPhone', imagePath: 'iphone' },
    { name: 'Laptop', imagePath: 'laptop' },
    { name: 'Oven', imagePath: 'oven' },
    { name: 'Washing Machine', imagePath: 'washingmachine' },
  ],

  'Throw': [
    { name: 'Trash', imagePath: 'trash' },
    { name: 'Frisbee', imagePath: 'frisbee' },
    { name: 'Paper Plane', imagePath: 'paperplane' },
  ],

  'Fold': [
    { name: 'Blanket', imagePath: 'blanket' },
  ],

  'Blow': [
    { name: 'Bubble', imagePath: 'bubble' },
    { name: 'Whistle', imagePath: 'whistle' },
    { name: 'Flute', imagePath: 'flute' },
    { name: 'Balloon', imagePath: 'balloon' },
  ],

  'Write': [
    // Removed 'Paper' to avoid overlap with 'Read'
    { name: 'Whiteboard', imagePath: 'whiteboard' },
    { name: 'Blackboard', imagePath: 'blackboard' },
    { name: 'Marker', imagePath: 'marker' },
    { name: 'Pencil', imagePath: 'pencil' },
    { name: 'Crayon', imagePath: 'crayon' },
    { name: 'Pen', imagePath: 'pen' },
  ],

  'Cut': [
    { name: 'String', imagePath: 'string' },
    { name: 'Saw', imagePath: 'saw' },
    { name: 'Scissors', imagePath: 'scissor' },
    { name: 'Knife', imagePath: 'knife' },
  ],

  'Wear': [
    { name: 'Shirt', imagePath: 'shirt' },
    { name: 'Jeans', imagePath: 'jeans' },
    { name: 'Underwear', imagePath: 'underwear' },
    { name: 'Hat', imagePath: 'hat' },
    { name: 'Jacket', imagePath: 'jacket' },
    { name: 'Coat', imagePath: 'coat' },
    { name: 'Shoe', imagePath: 'shoe' },
    { name: 'Dress', imagePath: 'dress' },
    { name: 'Raincoat', imagePath: 'raincoat' },
  ],

  'Sleep': [
    { name: 'Bed', imagePath: 'bed' },
    { name: 'Sleeping Bag', imagePath: 'sleepingbag' },
  ],

  'Wipe': [
    { name: 'Window', imagePath: 'window' },
    { name: 'Tissue', imagePath: 'tissue' },
    { name: 'Towel', imagePath: 'towel' },
  ],

  'Fly': [
    { name: 'Kite', imagePath: 'kite' },
    { name: 'Airplane', imagePath: 'airplane' },
    { name: 'Helicopter', imagePath: 'helicopter' },
  ],

  'Sit': [
    { name: 'Chair', imagePath: 'chair' },
    { name: 'Sofa', imagePath: 'sofa' },
    { name: 'Stool', imagePath: 'stool' },
    { name: 'Bench', imagePath: 'bench' },
  ],

  'Shake': [
    { name: 'Tambourine', imagePath: 'tambourine' },
    { name: 'Rattle', imagePath: 'rattle' },
    { name: 'Maraca', imagePath: 'maraca' },
  ],

  'Bathe': [
    { name: 'Soap', imagePath: 'soap' },
    { name: 'Shampoo', imagePath: 'shampoo' },
    { name: 'Shower', imagePath: 'shower' },
    { name: 'Sponge', imagePath: 'sponge' },
  ],

  'Open': [
    { name: 'Door', imagePath: 'door' },
    { name: 'Present', imagePath: 'present' },
    // Removed 'Window' to avoid overlap with 'Wipe'
    { name: 'Jar', imagePath: 'jar' },
  ],
};

// Helper function to get all functions
export function getAllFunctions() {
  return Object.keys(FUNCTION_ASSET_MAPPINGS);
}

// Helper function to get assets for a specific function
export function getAssetsForFunction(functionName) {
  return FUNCTION_ASSET_MAPPINGS[functionName] || [];
}

// Helper function to get all unique assets across all functions
export function getAllAssets() {
  const allAssets = new Map();
  Object.values(FUNCTION_ASSET_MAPPINGS).forEach(assets => {
    assets.forEach(asset => {
      allAssets.set(asset.imagePath, asset);
    });
  });
  return Array.from(allAssets.values());
}

// Helper function to convert to the format expected by Game 2
export function convertToGame2Format() {
  return Object.entries(FUNCTION_ASSET_MAPPINGS).map(([fn, assets]) => ({
    fn,
    correct: assets.map(asset => ({ 
      name: asset.name, 
      image: asset.imagePath 
    }))
  }));
}
